import React, { FC } from 'react';
import { UitkCard } from 'uitk-react-cards';
import { UitkLayoutFlex, UitkLayoutFlexItem } from 'uitk-react-layout-flex';
import { UitkIcon, UitkIconSize } from 'uitk-react-icons';
import { UitkText } from 'uitk-react-text';
import { UitkSpacing, UitkSpacingProps } from 'uitk-react-spacing';

interface MessageBannerProps {
  message: string;
  iconName?: string;
  spacing?: UitkSpacingProps;
  messageStyle?: React.CSSProperties;
}
const MessageBanner: FC<MessageBannerProps> = ({ message, iconName, spacing, messageStyle }) => {
  if (!message) return null;
  return (
    <UitkSpacing {...spacing}>
      <div>
        <UitkCard padded backgroundTheme="secondary">
          <UitkLayoutFlex alignItems="center" space="two">
            <UitkLayoutFlexItem>
              <div style={{ position: 'relative', top: '-1.5px', ...messageStyle }}>
                <UitkIcon name={iconName} theme="default" size={UitkIconSize.SMALL} />
              </div>
            </UitkLayoutFlexItem>
            <UitkLayoutFlexItem>
              <div>
                <UitkText theme="default" size={300}>
                  {message}
                </UitkText>
              </div>
            </UitkLayoutFlexItem>
          </UitkLayoutFlex>
        </UitkCard>
      </div>
    </UitkSpacing>
  );
};

export default MessageBanner;
